import dayjs from 'dayjs';

export const formatDates = (dates: string[]): string => {
  // Функция для получения месяца в формате "января"
  const getMonthName = (date: dayjs.Dayjs): string => {
    const months = [
      'января',
      'февраля',
      'марта',
      'апреля',
      'мая',
      'июня',
      'июля',
      'августа',
      'сентября',
      'октября',
      'ноября',
      'декабря',
    ];
    return months[date.month()];
  };

  // Сортируем даты
  const sortedDates = dates.map((date) => dayjs(date)).sort((a, b) => a.unix() - b.unix());

  const periods: string[] = [];
  let start = sortedDates[0];
  let end = start;

  for (let i = 1; i <= sortedDates.length; i++) {
    const current = sortedDates[i];
    const previous = sortedDates[i - 1];

    // Проверяем, последовательная ли дата
    if (current && current.diff(previous, 'day') === 1) {
      end = current; // Продолжаем диапазон
    } else {
      // Закрываем текущий диапазон
      const startDay = start.date();
      const endDay = end.date();
      const monthName = getMonthName(start);

      if (startDay === endDay) {
        // Одна дата
        periods.push(`${startDay} ${monthName}`);
      } else {
        // Диапазон дат
        periods.push(`${startDay}–${endDay} ${monthName}`);
      }

      // Начинаем новый диапазон
      start = current;
      end = current;
    }
  }

  return `${periods.join(', ')}.`;
};
